module.exports = __webpack_public_path__ + "img/7.ab45ca35.png";